import { Injectable } from '@angular/core';
import { LoadDataFacade, SetInitialStateFacade } from '../../../../../common/models';
import { Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import { AllocationViewProfile, AllocationViewProfileListSearchCriteria } from '../models';
import { AllocationViewProfileListState } from './allocation-view-profile-list.state';
import { ListServerPaginationStateModel } from '../../../../../common/models';
import { AllocationViewProfileListLoad } from './allocation-view-profile-list.actions';
import { ListSearchCriteriaType } from '../../../list-search-criteria';
import { ListSearchCriteriaFacade } from '../../../list-search-criteria/list-search-criteria.facade';

@Injectable({ providedIn: 'root' })
export class AllocationViewProfileListFacade implements SetInitialStateFacade, LoadDataFacade {
  listDto$: Observable<ListServerPaginationStateModel<AllocationViewProfile>> = this.store.select(
    AllocationViewProfileListState.getState,
  );
  items$: Observable<AllocationViewProfile[]> = this.store.select(AllocationViewProfileListState.getItems);
  loaded$: Observable<boolean> = this.store.select(AllocationViewProfileListState.getLoaded);

  constructor(private store: Store, private listSearchCriteriaFacade: ListSearchCriteriaFacade) {}

  loadAll(): void {
    this.listSearchCriteriaFacade
      .getSearchCriteriaByListType(ListSearchCriteriaType.AllocationViewProfiles)
      .subscribe((searchCriteria: AllocationViewProfileListSearchCriteria) => {
        this.store.dispatch(new AllocationViewProfileListLoad(searchCriteria));
      });
  }

  loadListForDialog(searchCriteria: AllocationViewProfileListSearchCriteria): void {
    this.store.dispatch(new AllocationViewProfileListLoad(searchCriteria));
  }

  setInitialState(): void {
    return;
  }
}
